import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth'

/** Defense in depth for the client only — the API routes behind these
 * pages (e.g. GET /api/admin/activity) reject non-operators regardless. */
export function OperatorRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  if (user?.role !== 'operator') return <Navigate to="/" replace />
  return <>{children}</>
}
